<template>
    <div class="talent-level-container">
        <div class="list-wrap">
            <div class="block width-1">
                <router-link class="button is-success" :to="{name:'addCartPrizeConfigEdit',query:{activityId:activityId}}">新增</router-link>
            </div>
            <div class="tile is-parent">
                <article class="tile is-child box">
                    <table class="table is-bordered">
                        <thead>
                        <tr>
                            <th>奖品ID</th>
                            <th>标题</th>
                            <th>类型</th>
                            <th>已领取／总数</th>
                            <th>操作</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item,index) in tableData" :key="index">
                            <td>{{item.prizeId}}</td>
                            <td>{{item.title}}</td>
                            <td>
                                <span v-if="item.type==1">优惠券</span>
                                <span v-if="item.type==2">其他</span>
                            </td>
                            <td>{{item.gotCount}}/{{item.totalCount}}</td>
                            <td>
                                <router-link class="button is-info" :to="{name:'addCartPrizeConfigEdit',query:{activityId:activityId,prizeId:item.prizeId}}">编辑</router-link>
                                <button class="button is-danger"  @click="removePrizeTag(item,index)">删除</button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </article>
            </div>
        </div>
    </div>
</template>
<script type="text/babel">
    export default{
        data(){
            return{
                tableData:[],
                activityId:null
            }
        },
        mounted: function () {
            this.activityId = parseInt(this.$route.query.activityId);
            this.$nextTick(function () {
                this.getPrizeList();
            })
        },
        methods:{
            /*
            * 点击删除触发
            * */
            removePrizeTag(item,index){
                if (confirm('是否确定删除?')) {
                    HttpRequest.get("/admin.php?method=cartactivity.removePrize",{activityId:this.activityId,prizeId:item.prizeId},true).then((response)=>{
                        if(response.data.success == 1){
                            this.$message("删除成功!");
                            this.tableData.splice(index,1);
                        }
                    })
                }
            },
            getPrizeList() {
                    HttpRequest.get('/admin.php?method=cartactivity.showPrize', {activityId:this.activityId},true).then((response) => {
                    this.tableData = response.data.list;
                })
            },
        }
    }
</script>
<style lang="less" scoped>
    .list-box{
        margin-bottom: 20px;
    }
    .remark-col{
        width: 300px;
    }
    .marginRight{
        margin-right: 5px;
        margin-bottom: 5px;
    }
</style>
